import { toast } from "sonner";
import { Copy, DownloadSimple } from "@phosphor-icons/react";

export const BackupCodes = ({ codes }) => {
  const text = codes.join("\n");
  const copy = async () => { await navigator.clipboard.writeText(text); toast.success("Backup codes copied"); };
  const download = () => {
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(new Blob([`CalibRunway backup codes\nEach code works once.\n\n${text}\n`], { type: "text/plain" })), download: "calibrunway-backup-codes.txt" });
    a.click();
    URL.revokeObjectURL(a.href);
  };
  return (
    <div data-testid="mfa-backup-codes">
      <p className="text-sm text-[#FFD166]">Save these backup codes somewhere safe. Each one works once if you lose your phone or can't get email. You won't see them again.</p>
      <div className="mt-3 grid grid-cols-2 gap-2 rounded-lg border border-[#2A2A2A] bg-[#050505] p-4 font-mono text-sm">
        {codes.map((c, i) => <span key={c} data-testid={`mfa-backup-code-${i}`}>{c}</span>)}
      </div>
      <div className="mt-3 flex gap-2">
        <button data-testid="mfa-backup-copy" onClick={copy} className="flex items-center gap-2 rounded-full border border-[#2A2A2A] px-4 py-2 text-xs hover:border-white transition-colors"><Copy size={13} /> Copy</button>
        <button data-testid="mfa-backup-download" onClick={download} className="flex items-center gap-2 rounded-full border border-[#2A2A2A] px-4 py-2 text-xs hover:border-white transition-colors"><DownloadSimple size={13} /> Download</button>
      </div>
    </div>
  );
};

export const CodeInput = ({ value, onChange, testid, backup }) => (
  <input data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} autoFocus autoComplete="one-time-code"
    inputMode={backup ? "text" : "numeric"} maxLength={backup ? 11 : 6} placeholder={backup ? "xxxxx-xxxxx" : "123456"}
    className="w-full rounded-lg bg-[#050505] border border-[#2A2A2A] px-4 py-3 text-center font-mono text-xl tracking-[0.4em] focus:outline-none focus:ring-2 focus:ring-[#00FF9D]" />
);
